<div *ngIf="data?.isVisible" [class]="'bugme' + animateme + fixme"
  [style]="'text-align:' + this.data?.align + ';' + zindexme" [class.bugmebar-bounceOutUp]="close">
  <div [innerHTML]="this.data.message"></div>
  <a [class]="'bugme-close' + this.closeme" (click)="closeBar(); false">{{ this.data.closeText }}</a>
</div>
